import { render, staticRenderFns } from "./TipoDeClientes.vue?vue&type=template&id=c917a9f2&"
import script from "./TipoDeClientes.vue?vue&type=script&lang=js&"
export * from "./TipoDeClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports